"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logUserAction = void 0;
const firestore_1 = require("firebase/firestore");
const logUserAction = async ({ action, artistGroupId, metadata, uid, }, firestore) => {
    try {
        await (0, firestore_1.addDoc)((0, firestore_1.collection)(firestore !== null && firestore !== void 0 ? firestore : (0, firestore_1.getFirestore)(), `artist_groups/${artistGroupId}/user_actions`), {
            createdAt: (0, firestore_1.serverTimestamp)(),
            action,
            uid,
            metadata: metadata || (0, firestore_1.deleteField)(),
        });
        return { success: true };
    }
    catch (err) {
        console.error(`There was a problem logging a user action: ${err.message}`);
        return { success: false };
    }
};
exports.logUserAction = logUserAction;
//# sourceMappingURL=actions.js.map